export const artists = [
  {
    id: '1',
    name: 'Marco Valencia',
    category: 'Soloist',
    genre: 'Jazz & Bossa Nova',
    bio: 'Vocalist and guitarist with over 15 years of experience on the most exclusive stages in Las Vegas. His warm voice transforms any event into an intimate and memorable experience.',
    imageUrl: 'https://readdy.ai/api/search-image?query=professional%20male%20singer%20performing%20solo%20with%20acoustic%20guitar%2C%20warm%20stage%20lighting%2C%20elegant%20venue%2C%20dark%20background%20with%20golden%20bokeh%2C%20professional%20portrait%20photography%2C%20sophisticated%20Las%20Vegas%20artist%2C%20casual%20elegant%20attire%2C%20intimate%20atmosphere&width=400&height=400&seq=15&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=professional%20male%20musician%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20elegant%20casual%20attire%2C%20confident%20expression%2C%20headshot%20style%2C%20Las%20Vegas%20artist%2C%20amber%20golden%20highlights%2C%20professional%20photography&width=200&height=200&seq=16&orientation=squarish',
    featured: true,
    eventTypes: ['Weddings', 'Receptions', 'Private Parties'],
    phone: '+1 (702) 555-0101',
    email: 'marco@valenciamusic.com',
    website: 'https://marco valencia.com',
    social: {
      instagram: '@marcovalencia',
      facebook: 'Marco Valencia Music',
      youtube: 'Marco Valencia',
    },
  },
  {
    id: '2',
    name: 'Duo Aurora',
    category: 'Duo',
    genre: 'Acoustic Pop',
    bio: "Elena and David's voices blend to create a unique atmosphere. They have played at over 200 corporate events and weddings in Las Vegas and the Reno area.",
    imageUrl: 'https://readdy.ai/api/search-image?query=musical%20duo%20male%20and%20female%20performers%20on%20stage%2C%20acoustic%20guitar%20and%20vocals%2C%20warm%20stage%20lighting%2C%20elegant%20venue%2C%20dark%20background%20with%20golden%20bokeh%2C%20professional%20photography%2C%20sophisticated%20Las%20Vegas%20entertainment%2C%20intimate%20atmosphere&width=400&height=400&seq=17&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=two%20musicians%20duo%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20elegant%20casual%20attire%2C%20professional%20headshot%2C%20Las%20Vegas%20artists%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20confident%20expressions&width=200&height=200&seq=18&orientation=squarish',
    featured: true,
    eventTypes: ['Weddings', 'Corporate Events', 'Receptions'],
    phone: '+1 (702) 555-0202',
    email: 'duoaurora@vegas.com',
    website: 'https://duo aurora.com',
    social: {
      instagram: '@duoaurora',
      facebook: 'Duo Aurora',
      youtube: 'Duo Aurora Official',
    },
  },
  {
    id: '3',
    name: 'Las Vegas Swing Trio',
    category: 'Trio',
    genre: 'Jazz & Swing',
    bio: 'Three jazz masters who bring the classic sound of Las Vegas halls to modern events. Piano, double bass, and saxophone in perfect harmony.',
    imageUrl: 'https://readdy.ai/api/search-image?query=jazz%20trio%20performing%20on%20elegant%20stage%2C%20piano%20bass%20and%20saxophone%2C%20warm%20golden%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20amber%20highlights%2C%20sophisticated%20Las%20Vegas%20lounge%20style%2C%20professional%20photography%2C%20vintage%20elegance&width=400&height=400&seq=19&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=three%20jazz%20musicians%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20elegant%20suits%2C%20professional%20headshot%2C%20Las%20Vegas%20artists%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20sophisticated%20expressions&width=200&height=200&seq=20&orientation=squarish',
    featured: true,
    eventTypes: ['Galas', 'Corporate Events', 'Receptions'],
    phone: '+1 (702) 555-0303',
    email: 'info@vegasswing.com',
    website: 'https://vegas swing.com',
    social: {
      instagram: '@vegasswingtrio',
      facebook: 'Las Vegas Swing Trio',
      youtube: 'Las Vegas Swing',
    },
  },
  {
    id: '4',
    name: 'Elite Quartet',
    category: 'Quartet',
    genre: 'Classical & Pop',
    bio: 'String quartet that has accompanied the most prestigious events in Las Vegas. From Mozart classics to today\'s hits, their versatility is unmatched.',
    imageUrl: 'https://readdy.ai/api/search-image?query=string%20quartet%20performing%20on%20elegant%20stage%2C%20four%20musicians%20with%20violins%20and%20cello%2C%20warm%20golden%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20amber%20highlights%2C%20sophisticated%20Las%20Vegas%20venue%2C%20professional%20photography%2C%20classical%20elegance&width=400&height=400&seq=21&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=string%20quartet%20musicians%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20elegant%20formal%20attire%2C%20professional%20headshot%2C%20Las%20Vegas%20artists%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20sophisticated%20expressions&width=200&height=200&seq=22&orientation=squarish',
    featured: true,
    eventTypes: ['Weddings', 'Galas', 'Special Celebrations'],
    phone: '+1 (702) 555-0404',
    email: 'contact@elitequartet.com',
    website: 'https://elitequartet.com',
    social: {
      instagram: '@elitequartet',
      facebook: 'Elite Quartet',
      youtube: 'Elite Quartet',
    },
  },
  {
    id: '5',
    name: 'Soul Fire Quintet',
    category: 'Quintet',
    genre: 'Soul & R&B',
    bio: 'Five musical souls that ignite any dance floor. With roots in Memphis soul and the energy of Las Vegas, every show is a party.',
    imageUrl: 'https://readdy.ai/api/search-image?query=soul%20band%20performing%20on%20stage%20with%20brass%20section%2C%20five%20musicians%20with%20high%20energy%2C%20warm%20golden%20and%20amber%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20spectacular%20lights%2C%20Las%20Vegas%20show%20style%2C%20professional%20photography%2C%20dynamic%20performance&width=400&height=400&seq=23&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=soul%20band%20five%20musicians%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20stylish%20casual%20attire%2C%20professional%20headshot%2C%20Las%20Vegas%20artists%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20energetic%20expressions&width=200&height=200&seq=24&orientation=squarish',
    featured: true,
    eventTypes: ['Private Parties', 'Corporate Events', 'Special Celebrations'],
    phone: '+1 (702) 555-0505',
    email: 'book@soulfireband.com',
    website: 'https://soulfireband.com',
    social: {
      instagram: '@soulfireband',
      facebook: 'Soul Fire Quintet',
      youtube: 'Soul Fire Band',
    },
  },
  {
    id: '6',
    name: 'Nevada Lights Band',
    category: 'Full Band',
    genre: 'Pop Rock & Latin',
    bio: 'The most requested band in Las Vegas for weddings and corporate events. With 8 members and a repertoire of over 300 songs, they guarantee an unforgettable night.',
    imageUrl: 'https://readdy.ai/api/search-image?query=full%20band%20performing%20on%20Las%20Vegas%20concert%20stage%2C%20large%20ensemble%20with%20drums%20guitars%20keyboards%20and%20vocals%2C%20dramatic%20stage%20lighting%20with%20amber%20and%20gold%2C%20professional%20photography%2C%20dark%20background%20with%20spectacular%20concert%20lights%2C%20high%20energy%20performance%2C%20professional%20musicians&width=400&height=400&seq=25&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=full%20band%20group%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20stylish%20performance%20attire%2C%20professional%20headshot%2C%20Las%20Vegas%20band%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20confident%20expressions%2C%20large%20ensemble&width=200&height=200&seq=26&orientation=squarish',
    featured: true,
    eventTypes: ['Weddings', 'Private Parties', 'Special Celebrations', 'Corporate Events'],
    phone: '+1 (702) 555-0606',
    email: 'info@nevadalights.com',
    website: 'https://nevadalights.com',
    social: {
      instagram: '@nevadalightsband',
      facebook: 'Nevada Lights Band',
      youtube: 'Nevada Lights Band',
    },
  },
  {
    id: '7',
    name: 'Sarah Mitchell',
    category: 'Soloist',
    genre: 'Pop & Ballads',
    bio: 'A powerful vocalist with a soulful voice that captivates audiences. Sarah has been a headlining act at several Las Vegas lounges and private venues.',
    imageUrl: 'https://readdy.ai/api/search-image?query=female%20solo%20singer%20performing%20on%20elegant%20stage%2C%20warm%20golden%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20amber%20bokeh%2C%20sophisticated%20Las%20Vegas%20artist%2C%20elegant%20evening%20dress%2C%20professional%20portrait%20photography%2C%20intimate%20venue&width=400&height=400&seq=50&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=professional%20female%20singer%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20elegant%20evening%20attire%2C%20confident%20expression%2C%20headshot%20style%2C%20Las%20Vegas%20artist%2C%20amber%20golden%20highlights%2C%20professional%20photography&width=200&height=200&seq=51&orientation=squarish',
    featured: false,
    eventTypes: ['Weddings', 'Receptions', 'Galas', 'Private Parties'],
    phone: '+1 (702) 555-0707',
    email: 'sarah@sarahmitchellmusic.com',
    website: 'https://sarahmitchellmusic.com',
    social: {
      instagram: '@sarahmitchellmusic',
      facebook: 'Sarah Mitchell Music',
      youtube: 'Sarah Mitchell',
    },
  },
  {
    id: '8',
    name: 'The Jazz Corner',
    category: 'Duo',
    genre: 'Jazz & Blues',
    bio: 'An instrumental duo featuring piano and saxophone that creates the perfect ambiance for cocktail hours and sophisticated receptions.',
    imageUrl: 'https://readdy.ai/api/search-image?query=jazz%20instrumental%20duo%20performing%20on%20elegant%20stage%2C%20piano%20and%20saxophone%2C%20warm%20golden%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20amber%20highlights%2C%20sophisticated%20Las%20Vegas%20lounge%2C%20professional%20photography%2C%20intimate%20mood&width=400&height=400&seq=52&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=two%20jazz%20musicians%20portrait%2C%20piano%20and%20saxophone%2C%20warm%20lighting%2C%20dark%20background%2C%20elegant%20suits%2C%20professional%20headshot%2C%20Las%20Vegas%20artists%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20sophisticated%20expressions&width=200&height=200&seq=53&orientation=squarish',
    featured: false,
    eventTypes: ['Receptions', 'Corporate Events', 'Networking'],
    phone: '+1 (702) 555-0808',
    email: 'booking@jazzcornervegas.com',
    website: 'https://jazzcornervegas.com',
    social: {
      instagram: '@jazzcornervegas',
      facebook: 'The Jazz Corner',
      youtube: 'The Jazz Corner',
    },
  },
  {
    id: '9',
    name: 'Midnight Serenade',
    category: 'Trio',
    genre: 'Classical & Jazz',
    bio: 'A trio of classically trained musicians who effortlessly blend jazz and classical influences for a refined and elegant sound.',
    imageUrl: 'https://readdy.ai/api/search-image?query=classical%20jazz%20trio%20performing%20on%20elegant%20stage%2C%20cello%20violin%20and%20piano%2C%20warm%20golden%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20amber%20highlights%2C%20sophisticated%20Las%20Vegas%20venue%2C%20professional%20photography%2C%20refined%20elegance&width=400&height=400&seq=54&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=three%20classical%20musicians%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20elegant%20formal%20attire%2C%20professional%20headshot%2C%20Las%20Vegas%20artists%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20refined%20expressions&width=200&height=200&seq=55&orientation=squarish',
    featured: false,
    eventTypes: ['Weddings', 'Galas', 'Receptions', 'Special Celebrations'],
    phone: '+1 (702) 555-0909',
    email: 'info@midnightserenade.com',
    website: 'https://midnightserenade.com',
    social: {
      instagram: '@midnightserenade',
      facebook: 'Midnight Serenade',
      youtube: 'Midnight Serenade Official',
    },
  },
  {
    id: '10',
    name: 'Neon Groove',
    category: 'Quartet',
    genre: 'Funk & Disco',
    bio: 'A high-energy funk and disco quartet that brings the dance floor to life. Their infectious grooves and powerful vocals make every event unforgettable.',
    imageUrl: 'https://readdy.ai/api/search-image?query=funk%20disco%20band%20performing%20on%20colorful%20stage%2C%20four%20musicians%20with%20bass%20drums%20guitar%20and%20vocals%2C%20vibrant%20golden%20and%20amber%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20spectacular%20lights%2C%20Las%20Vegas%20dance%20floor%2C%20professional%20photography%2C%20energetic%20performance&width=400&height=400&seq=56&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=funk%20band%20four%20musicians%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20stylish%20casual%20attire%2C%20professional%20headshot%2C%20Las%20Vegas%20artists%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20energetic%20expressions&width=200&height=200&seq=57&orientation=squarish',
    featured: false,
    eventTypes: ['Private Parties', 'Corporate Events', 'Special Celebrations'],
    phone: '+1 (702) 555-1010',
    email: 'book@neongroove.com',
    website: 'https://neongroove.com',
    social: {
      instagram: '@neongroove',
      facebook: 'Neon Groove',
      youtube: 'Neon Groove',
    },
  },
  {
    id: '11',
    name: 'Sinatra Tribute Act',
    category: 'Soloist',
    genre: 'Classic Crooner',
    bio: 'A masterful tribute to the legendary Frank Sinatra. Complete with vintage style and authentic vocals, he brings the golden age of Vegas to your event.',
    imageUrl: 'https://readdy.ai/api/search-image?query=vintage%20male%20crooner%20singer%20performing%20on%20elegant%20stage%2C%20classic%20Las%20Vegas%20style%2C%20warm%20golden%20lighting%2C%20tuxedo%20attire%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20amber%20bokeh%2C%20sophisticated%20lounge%2C%20professional%20photography%2C%20retro%20glamour&width=400&height=400&seq=58&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=vintage%20male%20singer%20portrait%20in%20tuxedo%2C%20warm%20lighting%2C%20dark%20background%2C%20classic%20Las%20Vegas%20style%2C%20confident%20expression%2C%20headshot%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20retro%20elegance&width=200&height=200&seq=59&orientation=squarish',
    featured: false,
    eventTypes: ['Corporate Events', 'Galas', 'Receptions', 'Special Celebrations'],
    phone: '+1 (702) 555-1111',
    email: 'info@sinatratribute.com',
    website: 'https://sinatratribute.com',
    social: {
      instagram: '@sinatratribute',
      facebook: 'Sinatra Tribute Act',
      youtube: 'Sinatra Tribute',
    },
  },
  {
    id: '12',
    name: 'The Desert Roses',
    category: 'Sextet',
    genre: 'Country & Americana',
    bio: 'A six-piece band bringing authentic country and Americana sounds to the Las Vegas scene. From acoustic ballads to upbeat boot-stomping hits.',
    imageUrl: 'https://readdy.ai/api/search-image?query=country%20band%20performing%20on%20rustic%20stage%2C%20six%20musicians%20with%20guitars%20banjo%20fiddle%20and%20drums%2C%20warm%20golden%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20amber%20highlights%2C%20Las%20Vegas%20country%20venue%2C%20professional%20photography%2C%20authentic%20Americana&width=400&height=400&seq=60&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=country%20band%20six%20musicians%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20western%20casual%20attire%2C%20professional%20headshot%2C%20Las%20Vegas%20artists%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20rustic%20expressions&width=200&height=200&seq=61&orientation=squarish',
    featured: false,
    eventTypes: ['Weddings', 'Private Parties', 'Special Celebrations'],
    phone: '+1 (702) 555-1212',
    email: 'book@desertrosesband.com',
    website: 'https://desertrosesband.com',
    social: {
      instagram: '@desertrosesband',
      facebook: 'The Desert Roses',
      youtube: 'Desert Roses Band',
    },
  },
];

export const categories = [
  { id: 'soloists', name: 'Soloists', count: 2 },
  { id: 'duos', name: 'Duos', count: 2 },
  { id: 'trios', name: 'Trios', count: 2 },
  { id: 'quartets', name: 'Quartets', count: 2 },
  { id: 'quintets', name: 'Quintets', count: 1 },
  { id: 'sextets', name: 'Sextets', count: 1 },
  { id: 'full band', name: 'Full Band', count: 1 },
];

export const genres = [
  'Jazz & Bossa Nova',
  'Acoustic Pop',
  'Jazz & Swing',
  'Classical & Pop',
  'Soul & R&B',
  'Pop Rock & Latin',
  'Pop & Ballads',
  'Jazz & Blues',
  'Classical & Jazz',
  'Funk & Disco',
  'Classic Crooner',
  'Country & Americana',
];

export const eventTypes = [
  'Weddings',
  'Corporate Events',
  'Private Parties',
  'Galas',
  'Receptions',
  'Networking',
  'Special Celebrations',
];

export default artists;